/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as PathlessLayoutRouteImport } from './routes/_pathlessLayout'
import { Route as LoginRouteRouteImport } from './routes/login/route'
import { Route as PathlessLayoutTournamentRouteRouteImport } from './routes/_pathlessLayout/tournament/route'
import { Route as PathlessLayoutTeamsRouteRouteImport } from './routes/_pathlessLayout/teams/route'
import { Route as PathlessLayoutSystemStatusRouteRouteImport } from './routes/_pathlessLayout/system-status/route'
import { Route as PathlessLayoutSettingsRouteRouteImport } from './routes/_pathlessLayout/settings/route'
import { Route as PathlessLayoutScoutingRouteRouteImport } from './routes/_pathlessLayout/scouting/route'
import { Route as PathlessLayoutPrivacyPolicyRouteRouteImport } from './routes/_pathlessLayout/privacy-policy/route'
import { Route as PathlessLayoutPlayersRouteRouteImport } from './routes/_pathlessLayout/players/route'
import { Route as PathlessLayoutLeaderboardsRouteRouteImport } from './routes/_pathlessLayout/leaderboards/route'
import { Route as PathlessLayoutKpisRouteRouteImport } from './routes/_pathlessLayout/kpis/route'
import { Route as PathlessLayoutDashboardRouteRouteImport } from './routes/_pathlessLayout/dashboard/route'
import { Route as PathlessLayoutChatRouteRouteImport } from './routes/_pathlessLayout/chat/route'
import { Route as PathlessLayoutSettingsSplatRouteImport } from './routes/_pathlessLayout/settings/$'
import { Route as PathlessLayoutPlayersSplatRouteImport } from './routes/_pathlessLayout/players/$'
import { Route as PathlessLayoutLeaderboardsSplatRouteImport } from './routes/_pathlessLayout/leaderboards/$'
import { Route as PathlessLayoutChatSplatRouteImport } from './routes/_pathlessLayout/chat/$'
import { Route as PathlessLayoutTournamentRankingRouteRouteImport } from './routes/_pathlessLayout/tournament/ranking/route'
import { Route as PathlessLayoutTournamentPlayersRouteRouteImport } from './routes/_pathlessLayout/tournament/players/route'
import { Route as PathlessLayoutTournamentOverviewRouteRouteImport } from './routes/_pathlessLayout/tournament/overview/route'
import { Route as PathlessLayoutTournamentLinesRouteRouteImport } from './routes/_pathlessLayout/tournament/lines/route'
import { Route as PathlessLayoutTournamentGoalkeepersRouteRouteImport } from './routes/_pathlessLayout/tournament/goalkeepers/route'
import { Route as PathlessLayoutTournamentCompareRouteRouteImport } from './routes/_pathlessLayout/tournament/compare/route'
import { Route as PathlessLayoutSettingsNotificationsRouteRouteImport } from './routes/_pathlessLayout/settings/notifications/route'
import { Route as PathlessLayoutSettingsMultiplierRouteRouteImport } from './routes/_pathlessLayout/settings/multiplier/route'
import { Route as PathlessLayoutScoutingPlayersRouteRouteImport } from './routes/_pathlessLayout/scouting/players/route'
import { Route as PathlessLayoutScoutingGoalkeepersRouteRouteImport } from './routes/_pathlessLayout/scouting/goalkeepers/route'
import { Route as PathlessLayoutScoutingFollowedRouteRouteImport } from './routes/_pathlessLayout/scouting/followed/route'
import { Route as PathlessLayoutPlayerPlayerIdRouteRouteImport } from './routes/_pathlessLayout/player.$playerId/route'
import { Route as PathlessLayoutKpisDefaultRouteRouteImport } from './routes/_pathlessLayout/kpis/default/route'
import { Route as PathlessLayoutKpisCurrentRouteRouteImport } from './routes/_pathlessLayout/kpis/current/route'
import { Route as PathlessLayoutDashboardTeamcomparisonRouteRouteImport } from './routes/_pathlessLayout/dashboard/teamcomparison/route'
import { Route as PathlessLayoutDashboardPeriodDataRouteRouteImport } from './routes/_pathlessLayout/dashboard/period-data/route'
import { Route as PathlessLayoutDashboardOverviewRouteRouteImport } from './routes/_pathlessLayout/dashboard/overview/route'
import { Route as PathlessLayoutDashboardHeatMapRouteRouteImport } from './routes/_pathlessLayout/dashboard/heatMap/route'
import { Route as PathlessLayoutDashboardGameSummaryRouteRouteImport } from './routes/_pathlessLayout/dashboard/gameSummary/route'
import { Route as PathlessLayoutDashboardCompareRouteRouteImport } from './routes/_pathlessLayout/dashboard/compare/route'
import { Route as PathlessLayoutDashboardAnalyticsRouteRouteImport } from './routes/_pathlessLayout/dashboard/analytics/route'

const PathlessLayoutRoute = PathlessLayoutRouteImport.update({
  id: '/_pathlessLayout',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRouteRoute = LoginRouteRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const PathlessLayoutTournamentRouteRoute =
  PathlessLayoutTournamentRouteRouteImport.update({
    id: '/tournament',
    path: '/tournament',
    getParentRoute: () => PathlessLayoutRoute,
  } as any)
const PathlessLayoutTeamsRouteRoute =
  PathlessLayoutTeamsRouteRouteImport.update({
    id: '/teams',
    path: '/teams',
    getParentRoute: () => PathlessLayoutRoute,
  } as any)
const PathlessLayoutSystemStatusRouteRoute =
  PathlessLayoutSystemStatusRouteRouteImport.update({
    id: '/system-status',
    path: '/system-status',
    getParentRoute: () => PathlessLayoutRoute,
  } as any)
const PathlessLayoutSettingsRouteRoute =
  PathlessLayoutSettingsRouteRouteImport.update({
    id: '/settings',
    path: '/settings',
    getParentRoute: () => PathlessLayoutRoute,
  } as any)
const PathlessLayoutScoutingRouteRoute =
  PathlessLayoutScoutingRouteRouteImport.update({
    id: '/scouting',
    path: '/scouting',
    getParentRoute: () => PathlessLayoutRoute,
  } as any)
const PathlessLayoutPrivacyPolicyRouteRoute =
  PathlessLayoutPrivacyPolicyRouteRouteImport.update({
    id: '/privacy-policy',
    path: '/privacy-policy',
    getParentRoute: () => PathlessLayoutRoute,
  } as any)
const PathlessLayoutPlayersRouteRoute =
  PathlessLayoutPlayersRouteRouteImport.update({
    id: '/players',
    path: '/players',
    getParentRoute: () => PathlessLayoutRoute,
  } as any)
const PathlessLayoutLeaderboardsRouteRoute =
  PathlessLayoutLeaderboardsRouteRouteImport.update({
    id: '/leaderboards',
    path: '/leaderboards',
    getParentRoute: () => PathlessLayoutRoute,
  } as any)
const PathlessLayoutKpisRouteRoute = PathlessLayoutKpisRouteRouteImport.update({
  id: '/kpis',
  path: '/kpis',
  getParentRoute: () => PathlessLayoutRoute,
} as any)
const PathlessLayoutDashboardRouteRoute =
  PathlessLayoutDashboardRouteRouteImport.update({
    id: '/dashboard',
    path: '/dashboard',
    getParentRoute: () => PathlessLayoutRoute,
  } as any)
const PathlessLayoutChatRouteRoute = PathlessLayoutChatRouteRouteImport.update({
  id: '/chat',
  path: '/chat',
  getParentRoute: () => PathlessLayoutRoute,
} as any)
const PathlessLayoutSettingsSplatRoute =
  PathlessLayoutSettingsSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => PathlessLayoutSettingsRouteRoute,
  } as any)
const PathlessLayoutPlayersSplatRoute =
  PathlessLayoutPlayersSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => PathlessLayoutPlayersRouteRoute,
  } as any)
const PathlessLayoutLeaderboardsSplatRoute =
  PathlessLayoutLeaderboardsSplatRouteImport.update({
    id: '/$',
    path: '/$',
    getParentRoute: () => PathlessLayoutLeaderboardsRouteRoute,
  } as any)
const PathlessLayoutChatSplatRoute = PathlessLayoutChatSplatRouteImport.update({
  id: '/$',
  path: '/$',
  getParentRoute: () => PathlessLayoutChatRouteRoute,
} as any)
const PathlessLayoutTournamentRankingRouteRoute =
  PathlessLayoutTournamentRankingRouteRouteImport.update({
    id: '/ranking',
    path: '/ranking',
    getParentRoute: () => PathlessLayoutTournamentRouteRoute,
  } as any)
const PathlessLayoutTournamentPlayersRouteRoute =
  PathlessLayoutTournamentPlayersRouteRouteImport.update({
    id: '/players',
    path: '/players',
    getParentRoute: () => PathlessLayoutTournamentRouteRoute,
  } as any)
const PathlessLayoutTournamentOverviewRouteRoute =
  PathlessLayoutTournamentOverviewRouteRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => PathlessLayoutTournamentRouteRoute,
  } as any)
const PathlessLayoutTournamentLinesRouteRoute =
  PathlessLayoutTournamentLinesRouteRouteImport.update({
    id: '/lines',
    path: '/lines',
    getParentRoute: () => PathlessLayoutTournamentRouteRoute,
  } as any)
const PathlessLayoutTournamentGoalkeepersRouteRoute =
  PathlessLayoutTournamentGoalkeepersRouteRouteImport.update({
    id: '/goalkeepers',
    path: '/goalkeepers',
    getParentRoute: () => PathlessLayoutTournamentRouteRoute,
  } as any)
const PathlessLayoutTournamentCompareRouteRoute =
  PathlessLayoutTournamentCompareRouteRouteImport.update({
    id: '/compare',
    path: '/compare',
    getParentRoute: () => PathlessLayoutTournamentRouteRoute,
  } as any)
const PathlessLayoutSettingsNotificationsRouteRoute =
  PathlessLayoutSettingsNotificationsRouteRouteImport.update({
    id: '/notifications',
    path: '/notifications',
    getParentRoute: () => PathlessLayoutSettingsRouteRoute,
  } as any)
const PathlessLayoutSettingsMultiplierRouteRoute =
  PathlessLayoutSettingsMultiplierRouteRouteImport.update({
    id: '/multiplier',
    path: '/multiplier',
    getParentRoute: () => PathlessLayoutSettingsRouteRoute,
  } as any)
const PathlessLayoutScoutingPlayersRouteRoute =
  PathlessLayoutScoutingPlayersRouteRouteImport.update({
    id: '/players',
    path: '/players',
    getParentRoute: () => PathlessLayoutScoutingRouteRoute,
  } as any)
const PathlessLayoutScoutingGoalkeepersRouteRoute =
  PathlessLayoutScoutingGoalkeepersRouteRouteImport.update({
    id: '/goalkeepers',
    path: '/goalkeepers',
    getParentRoute: () => PathlessLayoutScoutingRouteRoute,
  } as any)
const PathlessLayoutScoutingFollowedRouteRoute =
  PathlessLayoutScoutingFollowedRouteRouteImport.update({
    id: '/followed',
    path: '/followed',
    getParentRoute: () => PathlessLayoutScoutingRouteRoute,
  } as any)
const PathlessLayoutPlayerPlayerIdRouteRoute =
  PathlessLayoutPlayerPlayerIdRouteRouteImport.update({
    id: '/player/$playerId',
    path: '/player/$playerId',
    getParentRoute: () => PathlessLayoutRoute,
  } as any)
const PathlessLayoutKpisDefaultRouteRoute =
  PathlessLayoutKpisDefaultRouteRouteImport.update({
    id: '/default',
    path: '/default',
    getParentRoute: () => PathlessLayoutKpisRouteRoute,
  } as any)
const PathlessLayoutKpisCurrentRouteRoute =
  PathlessLayoutKpisCurrentRouteRouteImport.update({
    id: '/current',
    path: '/current',
    getParentRoute: () => PathlessLayoutKpisRouteRoute,
  } as any)
const PathlessLayoutDashboardTeamcomparisonRouteRoute =
  PathlessLayoutDashboardTeamcomparisonRouteRouteImport.update({
    id: '/teamcomparison',
    path: '/teamcomparison',
    getParentRoute: () => PathlessLayoutDashboardRouteRoute,
  } as any)
const PathlessLayoutDashboardPeriodDataRouteRoute =
  PathlessLayoutDashboardPeriodDataRouteRouteImport.update({
    id: '/period-data',
    path: '/period-data',
    getParentRoute: () => PathlessLayoutDashboardRouteRoute,
  } as any)
const PathlessLayoutDashboardOverviewRouteRoute =
  PathlessLayoutDashboardOverviewRouteRouteImport.update({
    id: '/overview',
    path: '/overview',
    getParentRoute: () => PathlessLayoutDashboardRouteRoute,
  } as any)
const PathlessLayoutDashboardHeatMapRouteRoute =
  PathlessLayoutDashboardHeatMapRouteRouteImport.update({
    id: '/heatMap',
    path: '/heatMap',
    getParentRoute: () => PathlessLayoutDashboardRouteRoute,
  } as any)
const PathlessLayoutDashboardGameSummaryRouteRoute =
  PathlessLayoutDashboardGameSummaryRouteRouteImport.update({
    id: '/gameSummary',
    path: '/gameSummary',
    getParentRoute: () => PathlessLayoutDashboardRouteRoute,
  } as any)
const PathlessLayoutDashboardCompareRouteRoute =
  PathlessLayoutDashboardCompareRouteRouteImport.update({
    id: '/compare',
    path: '/compare',
    getParentRoute: () => PathlessLayoutDashboardRouteRoute,
  } as any)
const PathlessLayoutDashboardAnalyticsRouteRoute =
  PathlessLayoutDashboardAnalyticsRouteRouteImport.update({
    id: '/analytics',
    path: '/analytics',
    getParentRoute: () => PathlessLayoutDashboardRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/login': typeof LoginRouteRoute
  '/chat': typeof PathlessLayoutChatRouteRouteWithChildren
  '/dashboard': typeof PathlessLayoutDashboardRouteRouteWithChildren
  '/kpis': typeof PathlessLayoutKpisRouteRouteWithChildren
  '/leaderboards': typeof PathlessLayoutLeaderboardsRouteRouteWithChildren
  '/players': typeof PathlessLayoutPlayersRouteRouteWithChildren
  '/privacy-policy': typeof PathlessLayoutPrivacyPolicyRouteRoute
  '/scouting': typeof PathlessLayoutScoutingRouteRouteWithChildren
  '/settings': typeof PathlessLayoutSettingsRouteRouteWithChildren
  '/system-status': typeof PathlessLayoutSystemStatusRouteRoute
  '/teams': typeof PathlessLayoutTeamsRouteRoute
  '/tournament': typeof PathlessLayoutTournamentRouteRouteWithChildren
  '/dashboard/analytics': typeof PathlessLayoutDashboardAnalyticsRouteRoute
  '/dashboard/compare': typeof PathlessLayoutDashboardCompareRouteRoute
  '/dashboard/gameSummary': typeof PathlessLayoutDashboardGameSummaryRouteRoute
  '/dashboard/heatMap': typeof PathlessLayoutDashboardHeatMapRouteRoute
  '/dashboard/overview': typeof PathlessLayoutDashboardOverviewRouteRoute
  '/dashboard/period-data': typeof PathlessLayoutDashboardPeriodDataRouteRoute
  '/dashboard/teamcomparison': typeof PathlessLayoutDashboardTeamcomparisonRouteRoute
  '/kpis/current': typeof PathlessLayoutKpisCurrentRouteRoute
  '/kpis/default': typeof PathlessLayoutKpisDefaultRouteRoute
  '/player/$playerId': typeof PathlessLayoutPlayerPlayerIdRouteRoute
  '/scouting/followed': typeof PathlessLayoutScoutingFollowedRouteRoute
  '/scouting/goalkeepers': typeof PathlessLayoutScoutingGoalkeepersRouteRoute
  '/scouting/players': typeof PathlessLayoutScoutingPlayersRouteRoute
  '/settings/multiplier': typeof PathlessLayoutSettingsMultiplierRouteRoute
  '/settings/notifications': typeof PathlessLayoutSettingsNotificationsRouteRoute
  '/tournament/compare': typeof PathlessLayoutTournamentCompareRouteRoute
  '/tournament/goalkeepers': typeof PathlessLayoutTournamentGoalkeepersRouteRoute
  '/tournament/lines': typeof PathlessLayoutTournamentLinesRouteRoute
  '/tournament/overview': typeof PathlessLayoutTournamentOverviewRouteRoute
  '/tournament/players': typeof PathlessLayoutTournamentPlayersRouteRoute
  '/tournament/ranking': typeof PathlessLayoutTournamentRankingRouteRoute
  '/chat/$': typeof PathlessLayoutChatSplatRoute
  '/leaderboards/$': typeof PathlessLayoutLeaderboardsSplatRoute
  '/players/$': typeof PathlessLayoutPlayersSplatRoute
  '/settings/$': typeof PathlessLayoutSettingsSplatRoute
}
export interface FileRoutesByTo {
  '/login': typeof LoginRouteRoute
  '/chat': typeof PathlessLayoutChatRouteRouteWithChildren
  '/dashboard': typeof PathlessLayoutDashboardRouteRouteWithChildren
  '/kpis': typeof PathlessLayoutKpisRouteRouteWithChildren
  '/leaderboards': typeof PathlessLayoutLeaderboardsRouteRouteWithChildren
  '/players': typeof PathlessLayoutPlayersRouteRouteWithChildren
  '/privacy-policy': typeof PathlessLayoutPrivacyPolicyRouteRoute
  '/scouting': typeof PathlessLayoutScoutingRouteRouteWithChildren
  '/settings': typeof PathlessLayoutSettingsRouteRouteWithChildren
  '/system-status': typeof PathlessLayoutSystemStatusRouteRoute
  '/teams': typeof PathlessLayoutTeamsRouteRoute
  '/tournament': typeof PathlessLayoutTournamentRouteRouteWithChildren
  '/dashboard/analytics': typeof PathlessLayoutDashboardAnalyticsRouteRoute
  '/dashboard/compare': typeof PathlessLayoutDashboardCompareRouteRoute
  '/dashboard/gameSummary': typeof PathlessLayoutDashboardGameSummaryRouteRoute
  '/dashboard/heatMap': typeof PathlessLayoutDashboardHeatMapRouteRoute
  '/dashboard/overview': typeof PathlessLayoutDashboardOverviewRouteRoute
  '/dashboard/period-data': typeof PathlessLayoutDashboardPeriodDataRouteRoute
  '/dashboard/teamcomparison': typeof PathlessLayoutDashboardTeamcomparisonRouteRoute
  '/kpis/current': typeof PathlessLayoutKpisCurrentRouteRoute
  '/kpis/default': typeof PathlessLayoutKpisDefaultRouteRoute
  '/player/$playerId': typeof PathlessLayoutPlayerPlayerIdRouteRoute
  '/scouting/followed': typeof PathlessLayoutScoutingFollowedRouteRoute
  '/scouting/goalkeepers': typeof PathlessLayoutScoutingGoalkeepersRouteRoute
  '/scouting/players': typeof PathlessLayoutScoutingPlayersRouteRoute
  '/settings/multiplier': typeof PathlessLayoutSettingsMultiplierRouteRoute
  '/settings/notifications': typeof PathlessLayoutSettingsNotificationsRouteRoute
  '/tournament/compare': typeof PathlessLayoutTournamentCompareRouteRoute
  '/tournament/goalkeepers': typeof PathlessLayoutTournamentGoalkeepersRouteRoute
  '/tournament/lines': typeof PathlessLayoutTournamentLinesRouteRoute
  '/tournament/overview': typeof PathlessLayoutTournamentOverviewRouteRoute
  '/tournament/players': typeof PathlessLayoutTournamentPlayersRouteRoute
  '/tournament/ranking': typeof PathlessLayoutTournamentRankingRouteRoute
  '/chat/$': typeof PathlessLayoutChatSplatRoute
  '/leaderboards/$': typeof PathlessLayoutLeaderboardsSplatRoute
  '/players/$': typeof PathlessLayoutPlayersSplatRoute
  '/settings/$': typeof PathlessLayoutSettingsSplatRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/login': typeof LoginRouteRoute
  '/_pathlessLayout': typeof PathlessLayoutRouteWithChildren
  '/_pathlessLayout/chat': typeof PathlessLayoutChatRouteRouteWithChildren
  '/_pathlessLayout/dashboard': typeof PathlessLayoutDashboardRouteRouteWithChildren
  '/_pathlessLayout/kpis': typeof PathlessLayoutKpisRouteRouteWithChildren
  '/_pathlessLayout/leaderboards': typeof PathlessLayoutLeaderboardsRouteRouteWithChildren
  '/_pathlessLayout/players': typeof PathlessLayoutPlayersRouteRouteWithChildren
  '/_pathlessLayout/privacy-policy': typeof PathlessLayoutPrivacyPolicyRouteRoute
  '/_pathlessLayout/scouting': typeof PathlessLayoutScoutingRouteRouteWithChildren
  '/_pathlessLayout/settings': typeof PathlessLayoutSettingsRouteRouteWithChildren
  '/_pathlessLayout/system-status': typeof PathlessLayoutSystemStatusRouteRoute
  '/_pathlessLayout/teams': typeof PathlessLayoutTeamsRouteRoute
  '/_pathlessLayout/tournament': typeof PathlessLayoutTournamentRouteRouteWithChildren
  '/_pathlessLayout/dashboard/analytics': typeof PathlessLayoutDashboardAnalyticsRouteRoute
  '/_pathlessLayout/dashboard/compare': typeof PathlessLayoutDashboardCompareRouteRoute
  '/_pathlessLayout/dashboard/gameSummary': typeof PathlessLayoutDashboardGameSummaryRouteRoute
  '/_pathlessLayout/dashboard/heatMap': typeof PathlessLayoutDashboardHeatMapRouteRoute
  '/_pathlessLayout/dashboard/overview': typeof PathlessLayoutDashboardOverviewRouteRoute
  '/_pathlessLayout/dashboard/period-data': typeof PathlessLayoutDashboardPeriodDataRouteRoute
  '/_pathlessLayout/dashboard/teamcomparison': typeof PathlessLayoutDashboardTeamcomparisonRouteRoute
  '/_pathlessLayout/kpis/current': typeof PathlessLayoutKpisCurrentRouteRoute
  '/_pathlessLayout/kpis/default': typeof PathlessLayoutKpisDefaultRouteRoute
  '/_pathlessLayout/player/$playerId': typeof PathlessLayoutPlayerPlayerIdRouteRoute
  '/_pathlessLayout/scouting/followed': typeof PathlessLayoutScoutingFollowedRouteRoute
  '/_pathlessLayout/scouting/goalkeepers': typeof PathlessLayoutScoutingGoalkeepersRouteRoute
  '/_pathlessLayout/scouting/players': typeof PathlessLayoutScoutingPlayersRouteRoute
  '/_pathlessLayout/settings/multiplier': typeof PathlessLayoutSettingsMultiplierRouteRoute
  '/_pathlessLayout/settings/notifications': typeof PathlessLayoutSettingsNotificationsRouteRoute
  '/_pathlessLayout/tournament/compare': typeof PathlessLayoutTournamentCompareRouteRoute
  '/_pathlessLayout/tournament/goalkeepers': typeof PathlessLayoutTournamentGoalkeepersRouteRoute
  '/_pathlessLayout/tournament/lines': typeof PathlessLayoutTournamentLinesRouteRoute
  '/_pathlessLayout/tournament/overview': typeof PathlessLayoutTournamentOverviewRouteRoute
  '/_pathlessLayout/tournament/players': typeof PathlessLayoutTournamentPlayersRouteRoute
  '/_pathlessLayout/tournament/ranking': typeof PathlessLayoutTournamentRankingRouteRoute
  '/_pathlessLayout/chat/$': typeof PathlessLayoutChatSplatRoute
  '/_pathlessLayout/leaderboards/$': typeof PathlessLayoutLeaderboardsSplatRoute
  '/_pathlessLayout/players/$': typeof PathlessLayoutPlayersSplatRoute
  '/_pathlessLayout/settings/$': typeof PathlessLayoutSettingsSplatRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/login'
    | '/chat'
    | '/dashboard'
    | '/kpis'
    | '/leaderboards'
    | '/players'
    | '/privacy-policy'
    | '/scouting'
    | '/settings'
    | '/system-status'
    | '/teams'
    | '/tournament'
    | '/dashboard/analytics'
    | '/dashboard/compare'
    | '/dashboard/gameSummary'
    | '/dashboard/heatMap'
    | '/dashboard/overview'
    | '/dashboard/period-data'
    | '/dashboard/teamcomparison'
    | '/kpis/current'
    | '/kpis/default'
    | '/player/$playerId'
    | '/scouting/followed'
    | '/scouting/goalkeepers'
    | '/scouting/players'
    | '/settings/multiplier'
    | '/settings/notifications'
    | '/tournament/compare'
    | '/tournament/goalkeepers'
    | '/tournament/lines'
    | '/tournament/overview'
    | '/tournament/players'
    | '/tournament/ranking'
    | '/chat/$'
    | '/leaderboards/$'
    | '/players/$'
    | '/settings/$'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/login'
    | '/chat'
    | '/dashboard'
    | '/kpis'
    | '/leaderboards'
    | '/players'
    | '/privacy-policy'
    | '/scouting'
    | '/settings'
    | '/system-status'
    | '/teams'
    | '/tournament'
    | '/dashboard/analytics'
    | '/dashboard/compare'
    | '/dashboard/gameSummary'
    | '/dashboard/heatMap'
    | '/dashboard/overview'
    | '/dashboard/period-data'
    | '/dashboard/teamcomparison'
    | '/kpis/current'
    | '/kpis/default'
    | '/player/$playerId'
    | '/scouting/followed'
    | '/scouting/goalkeepers'
    | '/scouting/players'
    | '/settings/multiplier'
    | '/settings/notifications'
    | '/tournament/compare'
    | '/tournament/goalkeepers'
    | '/tournament/lines'
    | '/tournament/overview'
    | '/tournament/players'
    | '/tournament/ranking'
    | '/chat/$'
    | '/leaderboards/$'
    | '/players/$'
    | '/settings/$'
  id:
    | '__root__'
    | '/login'
    | '/_pathlessLayout'
    | '/_pathlessLayout/chat'
    | '/_pathlessLayout/dashboard'
    | '/_pathlessLayout/kpis'
    | '/_pathlessLayout/leaderboards'
    | '/_pathlessLayout/players'
    | '/_pathlessLayout/privacy-policy'
    | '/_pathlessLayout/scouting'
    | '/_pathlessLayout/settings'
    | '/_pathlessLayout/system-status'
    | '/_pathlessLayout/teams'
    | '/_pathlessLayout/tournament'
    | '/_pathlessLayout/dashboard/analytics'
    | '/_pathlessLayout/dashboard/compare'
    | '/_pathlessLayout/dashboard/gameSummary'
    | '/_pathlessLayout/dashboard/heatMap'
    | '/_pathlessLayout/dashboard/overview'
    | '/_pathlessLayout/dashboard/period-data'
    | '/_pathlessLayout/dashboard/teamcomparison'
    | '/_pathlessLayout/kpis/current'
    | '/_pathlessLayout/kpis/default'
    | '/_pathlessLayout/player/$playerId'
    | '/_pathlessLayout/scouting/followed'
    | '/_pathlessLayout/scouting/goalkeepers'
    | '/_pathlessLayout/scouting/players'
    | '/_pathlessLayout/settings/multiplier'
    | '/_pathlessLayout/settings/notifications'
    | '/_pathlessLayout/tournament/compare'
    | '/_pathlessLayout/tournament/goalkeepers'
    | '/_pathlessLayout/tournament/lines'
    | '/_pathlessLayout/tournament/overview'
    | '/_pathlessLayout/tournament/players'
    | '/_pathlessLayout/tournament/ranking'
    | '/_pathlessLayout/chat/$'
    | '/_pathlessLayout/leaderboards/$'
    | '/_pathlessLayout/players/$'
    | '/_pathlessLayout/settings/$'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  LoginRouteRoute: typeof LoginRouteRoute
  PathlessLayoutRoute: typeof PathlessLayoutRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_pathlessLayout': {
      id: '/_pathlessLayout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof PathlessLayoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_pathlessLayout/tournament': {
      id: '/_pathlessLayout/tournament'
      path: '/tournament'
      fullPath: '/tournament'
      preLoaderRoute: typeof PathlessLayoutTournamentRouteRouteImport
      parentRoute: typeof PathlessLayoutRoute
    }
    '/_pathlessLayout/teams': {
      id: '/_pathlessLayout/teams'
      path: '/teams'
      fullPath: '/teams'
      preLoaderRoute: typeof PathlessLayoutTeamsRouteRouteImport
      parentRoute: typeof PathlessLayoutRoute
    }
    '/_pathlessLayout/system-status': {
      id: '/_pathlessLayout/system-status'
      path: '/system-status'
      fullPath: '/system-status'
      preLoaderRoute: typeof PathlessLayoutSystemStatusRouteRouteImport
      parentRoute: typeof PathlessLayoutRoute
    }
    '/_pathlessLayout/settings': {
      id: '/_pathlessLayout/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof PathlessLayoutSettingsRouteRouteImport
      parentRoute: typeof PathlessLayoutRoute
    }
    '/_pathlessLayout/scouting': {
      id: '/_pathlessLayout/scouting'
      path: '/scouting'
      fullPath: '/scouting'
      preLoaderRoute: typeof PathlessLayoutScoutingRouteRouteImport
      parentRoute: typeof PathlessLayoutRoute
    }
    '/_pathlessLayout/privacy-policy': {
      id: '/_pathlessLayout/privacy-policy'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof PathlessLayoutPrivacyPolicyRouteRouteImport
      parentRoute: typeof PathlessLayoutRoute
    }
    '/_pathlessLayout/players': {
      id: '/_pathlessLayout/players'
      path: '/players'
      fullPath: '/players'
      preLoaderRoute: typeof PathlessLayoutPlayersRouteRouteImport
      parentRoute: typeof PathlessLayoutRoute
    }
    '/_pathlessLayout/leaderboards': {
      id: '/_pathlessLayout/leaderboards'
      path: '/leaderboards'
      fullPath: '/leaderboards'
      preLoaderRoute: typeof PathlessLayoutLeaderboardsRouteRouteImport
      parentRoute: typeof PathlessLayoutRoute
    }
    '/_pathlessLayout/kpis': {
      id: '/_pathlessLayout/kpis'
      path: '/kpis'
      fullPath: '/kpis'
      preLoaderRoute: typeof PathlessLayoutKpisRouteRouteImport
      parentRoute: typeof PathlessLayoutRoute
    }
    '/_pathlessLayout/dashboard': {
      id: '/_pathlessLayout/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof PathlessLayoutDashboardRouteRouteImport
      parentRoute: typeof PathlessLayoutRoute
    }
    '/_pathlessLayout/chat': {
      id: '/_pathlessLayout/chat'
      path: '/chat'
      fullPath: '/chat'
      preLoaderRoute: typeof PathlessLayoutChatRouteRouteImport
      parentRoute: typeof PathlessLayoutRoute
    }
    '/_pathlessLayout/settings/$': {
      id: '/_pathlessLayout/settings/$'
      path: '/$'
      fullPath: '/settings/$'
      preLoaderRoute: typeof PathlessLayoutSettingsSplatRouteImport
      parentRoute: typeof PathlessLayoutSettingsRouteRoute
    }
    '/_pathlessLayout/players/$': {
      id: '/_pathlessLayout/players/$'
      path: '/$'
      fullPath: '/players/$'
      preLoaderRoute: typeof PathlessLayoutPlayersSplatRouteImport
      parentRoute: typeof PathlessLayoutPlayersRouteRoute
    }
    '/_pathlessLayout/leaderboards/$': {
      id: '/_pathlessLayout/leaderboards/$'
      path: '/$'
      fullPath: '/leaderboards/$'
      preLoaderRoute: typeof PathlessLayoutLeaderboardsSplatRouteImport
      parentRoute: typeof PathlessLayoutLeaderboardsRouteRoute
    }
    '/_pathlessLayout/chat/$': {
      id: '/_pathlessLayout/chat/$'
      path: '/$'
      fullPath: '/chat/$'
      preLoaderRoute: typeof PathlessLayoutChatSplatRouteImport
      parentRoute: typeof PathlessLayoutChatRouteRoute
    }
    '/_pathlessLayout/tournament/ranking': {
      id: '/_pathlessLayout/tournament/ranking'
      path: '/ranking'
      fullPath: '/tournament/ranking'
      preLoaderRoute: typeof PathlessLayoutTournamentRankingRouteRouteImport
      parentRoute: typeof PathlessLayoutTournamentRouteRoute
    }
    '/_pathlessLayout/tournament/players': {
      id: '/_pathlessLayout/tournament/players'
      path: '/players'
      fullPath: '/tournament/players'
      preLoaderRoute: typeof PathlessLayoutTournamentPlayersRouteRouteImport
      parentRoute: typeof PathlessLayoutTournamentRouteRoute
    }
    '/_pathlessLayout/tournament/overview': {
      id: '/_pathlessLayout/tournament/overview'
      path: '/overview'
      fullPath: '/tournament/overview'
      preLoaderRoute: typeof PathlessLayoutTournamentOverviewRouteRouteImport
      parentRoute: typeof PathlessLayoutTournamentRouteRoute
    }
    '/_pathlessLayout/tournament/lines': {
      id: '/_pathlessLayout/tournament/lines'
      path: '/lines'
      fullPath: '/tournament/lines'
      preLoaderRoute: typeof PathlessLayoutTournamentLinesRouteRouteImport
      parentRoute: typeof PathlessLayoutTournamentRouteRoute
    }
    '/_pathlessLayout/tournament/goalkeepers': {
      id: '/_pathlessLayout/tournament/goalkeepers'
      path: '/goalkeepers'
      fullPath: '/tournament/goalkeepers'
      preLoaderRoute: typeof PathlessLayoutTournamentGoalkeepersRouteRouteImport
      parentRoute: typeof PathlessLayoutTournamentRouteRoute
    }
    '/_pathlessLayout/tournament/compare': {
      id: '/_pathlessLayout/tournament/compare'
      path: '/compare'
      fullPath: '/tournament/compare'
      preLoaderRoute: typeof PathlessLayoutTournamentCompareRouteRouteImport
      parentRoute: typeof PathlessLayoutTournamentRouteRoute
    }
    '/_pathlessLayout/settings/notifications': {
      id: '/_pathlessLayout/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof PathlessLayoutSettingsNotificationsRouteRouteImport
      parentRoute: typeof PathlessLayoutSettingsRouteRoute
    }
    '/_pathlessLayout/settings/multiplier': {
      id: '/_pathlessLayout/settings/multiplier'
      path: '/multiplier'
      fullPath: '/settings/multiplier'
      preLoaderRoute: typeof PathlessLayoutSettingsMultiplierRouteRouteImport
      parentRoute: typeof PathlessLayoutSettingsRouteRoute
    }
    '/_pathlessLayout/scouting/players': {
      id: '/_pathlessLayout/scouting/players'
      path: '/players'
      fullPath: '/scouting/players'
      preLoaderRoute: typeof PathlessLayoutScoutingPlayersRouteRouteImport
      parentRoute: typeof PathlessLayoutScoutingRouteRoute
    }
    '/_pathlessLayout/scouting/goalkeepers': {
      id: '/_pathlessLayout/scouting/goalkeepers'
      path: '/goalkeepers'
      fullPath: '/scouting/goalkeepers'
      preLoaderRoute: typeof PathlessLayoutScoutingGoalkeepersRouteRouteImport
      parentRoute: typeof PathlessLayoutScoutingRouteRoute
    }
    '/_pathlessLayout/scouting/followed': {
      id: '/_pathlessLayout/scouting/followed'
      path: '/followed'
      fullPath: '/scouting/followed'
      preLoaderRoute: typeof PathlessLayoutScoutingFollowedRouteRouteImport
      parentRoute: typeof PathlessLayoutScoutingRouteRoute
    }
    '/_pathlessLayout/player/$playerId': {
      id: '/_pathlessLayout/player/$playerId'
      path: '/player/$playerId'
      fullPath: '/player/$playerId'
      preLoaderRoute: typeof PathlessLayoutPlayerPlayerIdRouteRouteImport
      parentRoute: typeof PathlessLayoutRoute
    }
    '/_pathlessLayout/kpis/default': {
      id: '/_pathlessLayout/kpis/default'
      path: '/default'
      fullPath: '/kpis/default'
      preLoaderRoute: typeof PathlessLayoutKpisDefaultRouteRouteImport
      parentRoute: typeof PathlessLayoutKpisRouteRoute
    }
    '/_pathlessLayout/kpis/current': {
      id: '/_pathlessLayout/kpis/current'
      path: '/current'
      fullPath: '/kpis/current'
      preLoaderRoute: typeof PathlessLayoutKpisCurrentRouteRouteImport
      parentRoute: typeof PathlessLayoutKpisRouteRoute
    }
    '/_pathlessLayout/dashboard/teamcomparison': {
      id: '/_pathlessLayout/dashboard/teamcomparison'
      path: '/teamcomparison'
      fullPath: '/dashboard/teamcomparison'
      preLoaderRoute: typeof PathlessLayoutDashboardTeamcomparisonRouteRouteImport
      parentRoute: typeof PathlessLayoutDashboardRouteRoute
    }
    '/_pathlessLayout/dashboard/period-data': {
      id: '/_pathlessLayout/dashboard/period-data'
      path: '/period-data'
      fullPath: '/dashboard/period-data'
      preLoaderRoute: typeof PathlessLayoutDashboardPeriodDataRouteRouteImport
      parentRoute: typeof PathlessLayoutDashboardRouteRoute
    }
    '/_pathlessLayout/dashboard/overview': {
      id: '/_pathlessLayout/dashboard/overview'
      path: '/overview'
      fullPath: '/dashboard/overview'
      preLoaderRoute: typeof PathlessLayoutDashboardOverviewRouteRouteImport
      parentRoute: typeof PathlessLayoutDashboardRouteRoute
    }
    '/_pathlessLayout/dashboard/heatMap': {
      id: '/_pathlessLayout/dashboard/heatMap'
      path: '/heatMap'
      fullPath: '/dashboard/heatMap'
      preLoaderRoute: typeof PathlessLayoutDashboardHeatMapRouteRouteImport
      parentRoute: typeof PathlessLayoutDashboardRouteRoute
    }
    '/_pathlessLayout/dashboard/gameSummary': {
      id: '/_pathlessLayout/dashboard/gameSummary'
      path: '/gameSummary'
      fullPath: '/dashboard/gameSummary'
      preLoaderRoute: typeof PathlessLayoutDashboardGameSummaryRouteRouteImport
      parentRoute: typeof PathlessLayoutDashboardRouteRoute
    }
    '/_pathlessLayout/dashboard/compare': {
      id: '/_pathlessLayout/dashboard/compare'
      path: '/compare'
      fullPath: '/dashboard/compare'
      preLoaderRoute: typeof PathlessLayoutDashboardCompareRouteRouteImport
      parentRoute: typeof PathlessLayoutDashboardRouteRoute
    }
    '/_pathlessLayout/dashboard/analytics': {
      id: '/_pathlessLayout/dashboard/analytics'
      path: '/analytics'
      fullPath: '/dashboard/analytics'
      preLoaderRoute: typeof PathlessLayoutDashboardAnalyticsRouteRouteImport
      parentRoute: typeof PathlessLayoutDashboardRouteRoute
    }
  }
}

interface PathlessLayoutChatRouteRouteChildren {
  PathlessLayoutChatSplatRoute: typeof PathlessLayoutChatSplatRoute
}

const PathlessLayoutChatRouteRouteChildren: PathlessLayoutChatRouteRouteChildren =
  {
    PathlessLayoutChatSplatRoute: PathlessLayoutChatSplatRoute,
  }

const PathlessLayoutChatRouteRouteWithChildren =
  PathlessLayoutChatRouteRoute._addFileChildren(
    PathlessLayoutChatRouteRouteChildren,
  )

interface PathlessLayoutDashboardRouteRouteChildren {
  PathlessLayoutDashboardAnalyticsRouteRoute: typeof PathlessLayoutDashboardAnalyticsRouteRoute
  PathlessLayoutDashboardCompareRouteRoute: typeof PathlessLayoutDashboardCompareRouteRoute
  PathlessLayoutDashboardGameSummaryRouteRoute: typeof PathlessLayoutDashboardGameSummaryRouteRoute
  PathlessLayoutDashboardHeatMapRouteRoute: typeof PathlessLayoutDashboardHeatMapRouteRoute
  PathlessLayoutDashboardOverviewRouteRoute: typeof PathlessLayoutDashboardOverviewRouteRoute
  PathlessLayoutDashboardPeriodDataRouteRoute: typeof PathlessLayoutDashboardPeriodDataRouteRoute
  PathlessLayoutDashboardTeamcomparisonRouteRoute: typeof PathlessLayoutDashboardTeamcomparisonRouteRoute
}

const PathlessLayoutDashboardRouteRouteChildren: PathlessLayoutDashboardRouteRouteChildren =
  {
    PathlessLayoutDashboardAnalyticsRouteRoute:
      PathlessLayoutDashboardAnalyticsRouteRoute,
    PathlessLayoutDashboardCompareRouteRoute:
      PathlessLayoutDashboardCompareRouteRoute,
    PathlessLayoutDashboardGameSummaryRouteRoute:
      PathlessLayoutDashboardGameSummaryRouteRoute,
    PathlessLayoutDashboardHeatMapRouteRoute:
      PathlessLayoutDashboardHeatMapRouteRoute,
    PathlessLayoutDashboardOverviewRouteRoute:
      PathlessLayoutDashboardOverviewRouteRoute,
    PathlessLayoutDashboardPeriodDataRouteRoute:
      PathlessLayoutDashboardPeriodDataRouteRoute,
    PathlessLayoutDashboardTeamcomparisonRouteRoute:
      PathlessLayoutDashboardTeamcomparisonRouteRoute,
  }

const PathlessLayoutDashboardRouteRouteWithChildren =
  PathlessLayoutDashboardRouteRoute._addFileChildren(
    PathlessLayoutDashboardRouteRouteChildren,
  )

interface PathlessLayoutKpisRouteRouteChildren {
  PathlessLayoutKpisCurrentRouteRoute: typeof PathlessLayoutKpisCurrentRouteRoute
  PathlessLayoutKpisDefaultRouteRoute: typeof PathlessLayoutKpisDefaultRouteRoute
}

const PathlessLayoutKpisRouteRouteChildren: PathlessLayoutKpisRouteRouteChildren =
  {
    PathlessLayoutKpisCurrentRouteRoute: PathlessLayoutKpisCurrentRouteRoute,
    PathlessLayoutKpisDefaultRouteRoute: PathlessLayoutKpisDefaultRouteRoute,
  }

const PathlessLayoutKpisRouteRouteWithChildren =
  PathlessLayoutKpisRouteRoute._addFileChildren(
    PathlessLayoutKpisRouteRouteChildren,
  )

interface PathlessLayoutLeaderboardsRouteRouteChildren {
  PathlessLayoutLeaderboardsSplatRoute: typeof PathlessLayoutLeaderboardsSplatRoute
}

const PathlessLayoutLeaderboardsRouteRouteChildren: PathlessLayoutLeaderboardsRouteRouteChildren =
  {
    PathlessLayoutLeaderboardsSplatRoute: PathlessLayoutLeaderboardsSplatRoute,
  }

const PathlessLayoutLeaderboardsRouteRouteWithChildren =
  PathlessLayoutLeaderboardsRouteRoute._addFileChildren(
    PathlessLayoutLeaderboardsRouteRouteChildren,
  )

interface PathlessLayoutPlayersRouteRouteChildren {
  PathlessLayoutPlayersSplatRoute: typeof PathlessLayoutPlayersSplatRoute
}

const PathlessLayoutPlayersRouteRouteChildren: PathlessLayoutPlayersRouteRouteChildren =
  {
    PathlessLayoutPlayersSplatRoute: PathlessLayoutPlayersSplatRoute,
  }

const PathlessLayoutPlayersRouteRouteWithChildren =
  PathlessLayoutPlayersRouteRoute._addFileChildren(
    PathlessLayoutPlayersRouteRouteChildren,
  )

interface PathlessLayoutScoutingRouteRouteChildren {
  PathlessLayoutScoutingFollowedRouteRoute: typeof PathlessLayoutScoutingFollowedRouteRoute
  PathlessLayoutScoutingGoalkeepersRouteRoute: typeof PathlessLayoutScoutingGoalkeepersRouteRoute
  PathlessLayoutScoutingPlayersRouteRoute: typeof PathlessLayoutScoutingPlayersRouteRoute
}

const PathlessLayoutScoutingRouteRouteChildren: PathlessLayoutScoutingRouteRouteChildren =
  {
    PathlessLayoutScoutingFollowedRouteRoute:
      PathlessLayoutScoutingFollowedRouteRoute,
    PathlessLayoutScoutingGoalkeepersRouteRoute:
      PathlessLayoutScoutingGoalkeepersRouteRoute,
    PathlessLayoutScoutingPlayersRouteRoute:
      PathlessLayoutScoutingPlayersRouteRoute,
  }

const PathlessLayoutScoutingRouteRouteWithChildren =
  PathlessLayoutScoutingRouteRoute._addFileChildren(
    PathlessLayoutScoutingRouteRouteChildren,
  )

interface PathlessLayoutSettingsRouteRouteChildren {
  PathlessLayoutSettingsMultiplierRouteRoute: typeof PathlessLayoutSettingsMultiplierRouteRoute
  PathlessLayoutSettingsNotificationsRouteRoute: typeof PathlessLayoutSettingsNotificationsRouteRoute
  PathlessLayoutSettingsSplatRoute: typeof PathlessLayoutSettingsSplatRoute
}

const PathlessLayoutSettingsRouteRouteChildren: PathlessLayoutSettingsRouteRouteChildren =
  {
    PathlessLayoutSettingsMultiplierRouteRoute:
      PathlessLayoutSettingsMultiplierRouteRoute,
    PathlessLayoutSettingsNotificationsRouteRoute:
      PathlessLayoutSettingsNotificationsRouteRoute,
    PathlessLayoutSettingsSplatRoute: PathlessLayoutSettingsSplatRoute,
  }

const PathlessLayoutSettingsRouteRouteWithChildren =
  PathlessLayoutSettingsRouteRoute._addFileChildren(
    PathlessLayoutSettingsRouteRouteChildren,
  )

interface PathlessLayoutTournamentRouteRouteChildren {
  PathlessLayoutTournamentCompareRouteRoute: typeof PathlessLayoutTournamentCompareRouteRoute
  PathlessLayoutTournamentGoalkeepersRouteRoute: typeof PathlessLayoutTournamentGoalkeepersRouteRoute
  PathlessLayoutTournamentLinesRouteRoute: typeof PathlessLayoutTournamentLinesRouteRoute
  PathlessLayoutTournamentOverviewRouteRoute: typeof PathlessLayoutTournamentOverviewRouteRoute
  PathlessLayoutTournamentPlayersRouteRoute: typeof PathlessLayoutTournamentPlayersRouteRoute
  PathlessLayoutTournamentRankingRouteRoute: typeof PathlessLayoutTournamentRankingRouteRoute
}

const PathlessLayoutTournamentRouteRouteChildren: PathlessLayoutTournamentRouteRouteChildren =
  {
    PathlessLayoutTournamentCompareRouteRoute:
      PathlessLayoutTournamentCompareRouteRoute,
    PathlessLayoutTournamentGoalkeepersRouteRoute:
      PathlessLayoutTournamentGoalkeepersRouteRoute,
    PathlessLayoutTournamentLinesRouteRoute:
      PathlessLayoutTournamentLinesRouteRoute,
    PathlessLayoutTournamentOverviewRouteRoute:
      PathlessLayoutTournamentOverviewRouteRoute,
    PathlessLayoutTournamentPlayersRouteRoute:
      PathlessLayoutTournamentPlayersRouteRoute,
    PathlessLayoutTournamentRankingRouteRoute:
      PathlessLayoutTournamentRankingRouteRoute,
  }

const PathlessLayoutTournamentRouteRouteWithChildren =
  PathlessLayoutTournamentRouteRoute._addFileChildren(
    PathlessLayoutTournamentRouteRouteChildren,
  )

interface PathlessLayoutRouteChildren {
  PathlessLayoutChatRouteRoute: typeof PathlessLayoutChatRouteRouteWithChildren
  PathlessLayoutDashboardRouteRoute: typeof PathlessLayoutDashboardRouteRouteWithChildren
  PathlessLayoutKpisRouteRoute: typeof PathlessLayoutKpisRouteRouteWithChildren
  PathlessLayoutLeaderboardsRouteRoute: typeof PathlessLayoutLeaderboardsRouteRouteWithChildren
  PathlessLayoutPlayersRouteRoute: typeof PathlessLayoutPlayersRouteRouteWithChildren
  PathlessLayoutPrivacyPolicyRouteRoute: typeof PathlessLayoutPrivacyPolicyRouteRoute
  PathlessLayoutScoutingRouteRoute: typeof PathlessLayoutScoutingRouteRouteWithChildren
  PathlessLayoutSettingsRouteRoute: typeof PathlessLayoutSettingsRouteRouteWithChildren
  PathlessLayoutSystemStatusRouteRoute: typeof PathlessLayoutSystemStatusRouteRoute
  PathlessLayoutTeamsRouteRoute: typeof PathlessLayoutTeamsRouteRoute
  PathlessLayoutTournamentRouteRoute: typeof PathlessLayoutTournamentRouteRouteWithChildren
  PathlessLayoutPlayerPlayerIdRouteRoute: typeof PathlessLayoutPlayerPlayerIdRouteRoute
}

const PathlessLayoutRouteChildren: PathlessLayoutRouteChildren = {
  PathlessLayoutChatRouteRoute: PathlessLayoutChatRouteRouteWithChildren,
  PathlessLayoutDashboardRouteRoute:
    PathlessLayoutDashboardRouteRouteWithChildren,
  PathlessLayoutKpisRouteRoute: PathlessLayoutKpisRouteRouteWithChildren,
  PathlessLayoutLeaderboardsRouteRoute:
    PathlessLayoutLeaderboardsRouteRouteWithChildren,
  PathlessLayoutPlayersRouteRoute: PathlessLayoutPlayersRouteRouteWithChildren,
  PathlessLayoutPrivacyPolicyRouteRoute: PathlessLayoutPrivacyPolicyRouteRoute,
  PathlessLayoutScoutingRouteRoute:
    PathlessLayoutScoutingRouteRouteWithChildren,
  PathlessLayoutSettingsRouteRoute:
    PathlessLayoutSettingsRouteRouteWithChildren,
  PathlessLayoutSystemStatusRouteRoute: PathlessLayoutSystemStatusRouteRoute,
  PathlessLayoutTeamsRouteRoute: PathlessLayoutTeamsRouteRoute,
  PathlessLayoutTournamentRouteRoute:
    PathlessLayoutTournamentRouteRouteWithChildren,
  PathlessLayoutPlayerPlayerIdRouteRoute:
    PathlessLayoutPlayerPlayerIdRouteRoute,
}

const PathlessLayoutRouteWithChildren = PathlessLayoutRoute._addFileChildren(
  PathlessLayoutRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  LoginRouteRoute: LoginRouteRoute,
  PathlessLayoutRoute: PathlessLayoutRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
